export const to_nested = (data, pid = null , parent_id_name = "parentId") => {
  try {
    return data?.reduce((r, e) => {
      if (pid == e?.[parent_id_name]) {
        const object = { ...e };
        const children = to_nested(data, e.id, parent_id_name);

        if (children.length) {
          object.children = children;
        }

        r.push(object);
      }

      return r;
    }, []);
  } catch (e) {
  }
};

export const unique_array = (array) => [...new Set(array)];

export const group_by = (arr, prop) => {
  const map = new Map(Array.from(arr, (obj) => [obj[prop], []]));
  arr.forEach((obj) => map.get(obj[prop]).push(obj));
  return Array.from(map.values());
};

export const group_by_with_normalize = (items, group_field_name) => {
  return items?.reduce(function (results, item) {
    (results[item[group_field_name]] =
      results[item[group_field_name]] || []).push(item);
    return results;
  }, {});
};

export const array_unique_by_key = (array, key) => [
  ...new Map(array.map((item) => [item[key], item])).values(),
];